export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZGlhcmlhcmEiLCJhIjoiY2w2ZXU5bXV4MGlkczNkcW92b28yaDZhdiJ9.tvNkBuIYVXtyNMfZ0vJpwg'
export const mapStyle = 'mapbox://styles/diariara/clhsuubb4023301pg5r4nf18c'

const BASE_INITIAL_VIEW = {
	longitude: 1.6,
	latitude: 41.687,
	zoom: 7.41,
}
const CATALONIA_BOUNDS = {
	west: 0.16,
	east: 3.33,
	south: 40.52,
	north: 42.9,
}
const WORLD_SIZE = 512

const clamp = (value, min, max) => Math.min(max, Math.max(min, value))

const latToMercatorY = (lat) => {
	const safeLat = clamp(lat, -85.05112878, 85.05112878)
	const rad = (safeLat * Math.PI) / 180
	return Math.log(Math.tan(Math.PI / 4 + rad / 2))
}

const mercatorYToLat = (mercatorY) => {
	const rad = 2 * Math.atan(Math.exp(mercatorY)) - Math.PI / 2
	return (rad * 180) / Math.PI
}
export const getInitialViewByWidth = (width, height = 0) => {
	if (!width) {
		return BASE_INITIAL_VIEW
	}

	const fallbackAspectRatio = width >= 768 ? 4 / 3 : 2 / 3
	const computedHeight = height || width / fallbackAspectRatio

	const isMobile = width < 768
	const horizontalPadding = isMobile ? 18 : 30
	const verticalPadding = isMobile ? 22 : 34

	const usableWidth = Math.max(width - horizontalPadding * 2, 1)
	const usableHeight = Math.max(computedHeight - verticalPadding * 2, 1)

	const lngDiff = CATALONIA_BOUNDS.east - CATALONIA_BOUNDS.west
	const latDiffMercator = Math.abs(latToMercatorY(CATALONIA_BOUNDS.north) - latToMercatorY(CATALONIA_BOUNDS.south))

	const zoomByLng = Math.log2((usableWidth * 360) / (WORLD_SIZE * lngDiff))
	const zoomByLat = Math.log2(usableHeight / (WORLD_SIZE * (latDiffMercator / (2 * Math.PI))))
	const zoom = clamp(Math.min(zoomByLng, zoomByLat), 5.8, 9.5)

	const centerLongitude = (CATALONIA_BOUNDS.west + CATALONIA_BOUNDS.east) / 2
	const centerMercatorY = (latToMercatorY(CATALONIA_BOUNDS.north) + latToMercatorY(CATALONIA_BOUNDS.south)) / 2

	return {
		longitude: centerLongitude,
		latitude: mercatorYToLat(centerMercatorY),
		zoom,
	}
}
